import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Dashboard/";

const getAllJobs = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetAllJobs', constants.REQUIRE_INTERCEPTORS);

const getTeamMembers = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetTeamMembers?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getJobFinanicals = async (filters) => await axiosInstance.post(ENDPOINTORIGIN + 'GetJobFinanicals', filters, constants.REQUIRE_INTERCEPTORS);

const getEstimatedNumberOfDaysRemaining = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'getEstimatedNumberOfDaysRemaining?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getLatestLoginLocation = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetLatestLoginLocation', constants.REQUIRE_INTERCEPTORS);

const getScheduleForDashboard = async (isLoggedIn,switchMode) => await axiosInstance.get(ENDPOINTORIGIN + 'GetScheduleForDashboard?loggedInUser=' + isLoggedIn + '&newCalendarMode=' + switchMode, constants.REQUIRE_INTERCEPTORS);

const getJobScheduleForGroup = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'GetJobScheduleForGroup', model ,constants.REQUIRE_INTERCEPTORS);

const updateDescription = async (agenda) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateDescription', agenda, constants.REQUIRE_INTERCEPTORS);

export {
    getAllJobs,
    getTeamMembers,
    getJobFinanicals,
    getEstimatedNumberOfDaysRemaining,
    getLatestLoginLocation,
    getScheduleForDashboard,
    getJobScheduleForGroup,
    updateDescription
}